var map = {
	"./00006.png": 7658,
	"./00006_wide.png": 2017,
	"./00007.png": 2755,
	"./00007_wide.png": 4386,
	"./1091500.png": 4902,
	"./1091500_wide.png": 918,
	"./271590.png": 1334,
	"./79709895.png": 995,
	"./79709895_wide.png": 8611,
	"./amongus.png": 6386,
	"./flappy_chicken_reflec_nar.png": 4365,
	"./flappy_chicken_reflec_wide.png": 5423,
	"./netflixsmall.png": 5808,
	"./parking_at_bonn_reflec_nar.png": 5741,
	"./parking_at_bonn_reflec_wide.png": 4453,
	"./skyrim.png": 9275,
	"./the_crew2.png": 9016,
	"./tux_racer_reflec_nar.png": 8194,
	"./tux_racer_reflec_wide.png": 6205,
	"./witcher3.png": 3359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;